module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jill Kemerer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Jill Kemerer ")]), _vm._v("is a Publishers Weekly bestselling author of Christian romance novels. Her essentials include coffee, a stack of books, her mini-dachshund, and taking long nature walks. Jill resides in Ohio with her husband and two almost-grown children. She loves connecting with readers, so please visit her website, jillkemerer.com.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/doGW2D/tc-custom/9781460379943.jpg?1706797544433",
      "alt": "This image is the cover for the book Small-Town Bachelor"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Small-Town Bachelor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A Place to Call Home  "), _c('br'), _c('br'), _vm._v("When Reed Hamilton arrives in Lake Endwell for a family wedding, he expects to do his part as best man then head back to the big city. But when a a tornado postpones the wedding, the town is in shambles and Reed is injured. Thankfully maid of honor Claire Sheffield offers him one of her cottages to recuperate in. Dedicated to her family and her dream job at the zoo, Claire is all about roots. She's this city slicker's opposite, yet as they help the town rebuild, Reed is captivated by her stunning looks and caring ways. He can't ask Claire to leave the life she loves for him, but he also can't imagine ever leaving her behind")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0